/* ***************************************************************** */
/*                                                                   */
/* Licensed Materials - Property of Merative                         */
/*                                                                   */
/* (C) Copyright Merative Corp. 2025                                 */
/*                                                                   */
/* ***************************************************************** */
import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';
import {fetchAndHandleResponse} from "../../../../utils";

const INITIAL_STATE = {
    formula_names: [],
    nutrient_details: {},
}

const ACTION_TYPES = {
    NUTRIENT_DETAILS: 'NUTRIENT_DETAILS',
    NEONATAL_NUTRIENT_DETAILS: 'NEONATAL_NUTRIENT_DETAILS',
    PEDIATRICS_NUTRIENT_DETAILS: 'PEDIATRICS_NUTRIENT_DETAILS',
}

const processResponse = (responseBody, dispatch, params) => {
    const {docIds, resultType} = params;
    console.log("docIds", docIds);
    console.log("resultType", resultType);

    if (responseBody && responseBody.results) {
        console.log("Response received with status 200");
        if (responseBody.results) {
            dispatch(saveNutrientDetails({
                formula_names: params.formula_names,
                nutrient_details: responseBody.results,
                page_name: params.page_name,
                docIds: params.docIds,
                resultType: params.resultType,
                displayFormat: params.displayFormat
            }));
        }
    }
}

export const fetchDetails = createAsyncThunk('nutrientDetails', async (params, {
    dispatch,
    rejectWithValue
}) => {
    return await fetchAndHandleResponse(params, dispatch, rejectWithValue, processResponse);
});


const initialState = {
    data: {},
    docIds: [],
    resultType: "",
    displayFormat: "",
    status: 'idle', // 'idle' | 'loading' | 'succeeded' | 'failed'
    error: null,
    neofax_nutrient_details: INITIAL_STATE,
    pediatrics_nutrient_details: INITIAL_STATE
}

const nutrientDetailsSlice = createSlice({
    name: 'nutrient_details_page',
    initialState: initialState,
    reducers: {
        saveNutrientDetails: (state, action) => {
            console.log("saveNutrientDetails", action.payload);
            const {nutrient_details, page_name,docIds,resultType} = action.payload;
            state.type = ACTION_TYPES.NUTRIENT_DETAILS;
            state.page_name = page_name;
            state.data = nutrient_details;
            state.docIds = docIds;
            state.resultType = resultType;
            state.displayFormat = action.payload.displayFormat;
        },
        removeNutrientDetail: (state, action) => {
            const docId = action.payload.docId;
            state.docIds = state.docIds.filter(id => id !== docId);
            state.data.results = Object.keys(state.data.results)
              .filter(key => key !== docId)
              .reduce((acc, key) => {
                  acc[key] = state.data.results[key];
                  return acc;
              }, {});
        },
        clearNutrientDetailsState: (state) => {
            return initialState;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchDetails.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchDetails.fulfilled, (state, action) => {
                console.log('action.payload', action.payload);
                state.status = 'succeeded';
                state.data = action.payload; // Update the 'data' property instead of reassigning the state
                state.error = null;
            })
            .addCase(fetchDetails.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
            });
    }
});

export const {saveNutrientDetails, removeNutrientDetail, clearNutrientDetailsState} = nutrientDetailsSlice.actions;

export default nutrientDetailsSlice.reducer;

